import React from 'react';
import { 
  Box, 
  Grid, 
  Typography, 
  Paper,
  Tabs,
  Tab
} from '@mui/material';
import KneeFlexionChart from './KneeFlexionChart';
import HipFlexionChart from './HipFlexionChart';
import LegAngleChart from './LegAngleChart';
import AnkleAngleChart from './AnkleAngleChart';
import FlexionStats from './FlexionStats';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`flexion-tabpanel-${index}`}
      aria-labelledby={`flexion-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `flexion-tab-${index}`,
    'aria-controls': `flexion-tabpanel-${index}`,
  };
}

export default function FlexionAnalysisContainer({ timeSeriesData, flexionSummary, statistics }) {
  const [tabValue, setTabValue] = React.useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  console.log("🎯 FLEXION CONTAINER DEBUG - timeSeriesData:", timeSeriesData);
  console.log("🎯 FLEXION CONTAINER DEBUG - flexionSummary:", flexionSummary);
  console.log("🎯 FLEXION CONTAINER DEBUG - statistics:", statistics);

  if (!timeSeriesData || timeSeriesData.length === 0) {
    return (
      <Paper elevation={2} sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="h6" color="text.secondary">
          No gait analysis data available
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Please ensure the backend provides time_series_data
        </Typography>
      </Paper>
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Paper elevation={2}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs 
            value={tabValue} 
            onChange={handleTabChange} 
            aria-label="flexion analysis tabs"
            centered
          >
            <Tab label="Overview" {...a11yProps(0)} />
            <Tab label="Leg Angles (Norm)" {...a11yProps(1)} />
            <Tab label="Knee Flexion (Norm)" {...a11yProps(2)} />
            <Tab label="Hip Flexion (Norm)" {...a11yProps(3)} />
            <Tab label="Ankle Deflection (Norm)" {...a11yProps(4)} />
          </Tabs>
        </Box>

        {/* Overview Tab */}
        <TabPanel value={tabValue} index={0}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'center' }}>
            Normalized Gait Analysis Overview
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={6}>
              <LegAngleChart timeSeriesData={timeSeriesData} height="350px" />
            </Grid>
            <Grid item xs={12} lg={6}>
              <KneeFlexionChart timeSeriesData={timeSeriesData} height="350px" />
            </Grid>
            <Grid item xs={12} lg={6}>
              <HipFlexionChart timeSeriesData={timeSeriesData} height="350px" />
            </Grid>
            <Grid item xs={12} lg={6}>
              <AnkleAngleChart timeSeriesData={timeSeriesData} height="350px" />
            </Grid>
          </Grid>
        </TabPanel>

        {/* Leg Angles Tab */}
        <TabPanel value={tabValue} index={1}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'center' }}>
            Detailed Normalized Leg Angle Analysis
          </Typography>
          <LegAngleChart timeSeriesData={timeSeriesData} height="500px" />
        </TabPanel>

        {/* Knee Angles Tab */}
        <TabPanel value={tabValue} index={2}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'center' }}>
            Detailed Normalized Knee Flexion Analysis
          </Typography>
          <KneeFlexionChart timeSeriesData={timeSeriesData} height="500px" />
        </TabPanel>

        {/* Hip Angles Tab */}
        <TabPanel value={tabValue} index={3}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'center' }}>
            Detailed Normalized Hip Flexion Analysis
          </Typography>
          <HipFlexionChart timeSeriesData={timeSeriesData} height="500px" />
        </TabPanel>

        {/* Ankle Angles Tab */}
        <TabPanel value={tabValue} index={4}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'center' }}>
            Detailed Normalized Ankle Deflection Analysis
          </Typography>
          <AnkleAngleChart timeSeriesData={timeSeriesData} height="500px" />
        </TabPanel>
      </Paper>
    </Box>
  );
}
